(function () {
  var config = window.EbuyTheme || {};
  var strings = config.strings || {};
  if (config.predictiveSearch === false) return;

  function endpoint(query) {
    var root = (config.routes && config.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    var params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', '8');
    params.set('resources[options][unavailable_products]', 'last');
    params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,body,tag');
    return root + 'search/suggest.json?' + params.toString();
  }

  function priceText(product) {
    var price = product.price == null ? '' : String(product.price);
    if (!price) return '';
    if (/[A-Za-z$€£¥]/.test(price)) return price;
    var currency = config.currency ? config.currency + ' ' : '';
    return currency + price;
  }

  document.querySelectorAll('[data-search-form]').forEach(function (form) {
    var input = form.querySelector('input[name="q"]');
    var panel = form.querySelector('[data-predictive]');
    var list = form.querySelector('[data-predictive-list]');
    var empty = form.querySelector('[data-predictive-empty]');
    var all = form.querySelector('[data-predictive-all]');
    var error = form.querySelector('[data-search-error]');
    if (!input || !panel || !list) return;
    var controller = null;
    var timer = null;
    var active = -1;

    function clearPanel() {
      list.replaceChildren();
      panel.hidden = true;
      if (empty) empty.hidden = true;
      if (all) all.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    }

    function render(products, query) {
      list.replaceChildren();
      if (!products.length) {
        panel.hidden = false;
        if (empty) {
          empty.hidden = false;
          empty.textContent = strings.noMatching || 'No matching products.';
        }
        if (all) all.hidden = true;
        input.setAttribute('aria-expanded', 'true');
        return;
      }
      if (empty) empty.hidden = true;
      products.forEach(function (product) {
        var item = document.createElement('li');
        item.className = 'predictive__item';
        item.setAttribute('role', 'presentation');
        var link = document.createElement('a');
        link.href = product.url;
        link.setAttribute('role', 'option');
        if (product.image || (product.featured_image && product.featured_image.url)) {
          var img = document.createElement('img');
          img.src = product.featured_image && product.featured_image.url ? product.featured_image.url : product.image;
          img.alt = '';
          img.width = 48;
          img.height = 48;
          link.appendChild(img);
        } else {
          var spacer = document.createElement('span');
          link.appendChild(spacer);
        }
        var text = document.createElement('span');
        var title = document.createElement('span');
        title.className = 'predictive__title';
        title.textContent = product.title || '';
        var meta = document.createElement('span');
        meta.className = 'predictive__meta';
        if (priceText(product)) meta.appendChild(document.createTextNode(priceText(product)));
        if (product.available === false) meta.appendChild(document.createTextNode(' · ' + (strings.soldOut || 'Sold out')));
        text.appendChild(title);
        text.appendChild(document.createElement('br'));
        text.appendChild(meta);
        link.appendChild(text);
        item.appendChild(link);
        list.appendChild(item);
      });
      if (all) {
        var root = (config.routes && config.routes.search) || '/search';
        all.href = root + '?type=product&q=' + encodeURIComponent(query);
        all.hidden = false;
      }
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function search(query) {
      if (controller) controller.abort();
      controller = new AbortController();
      fetch(endpoint(query), { signal: controller.signal, headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('search');
          return response.json();
        })
        .then(function (data) {
          var products = data && data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
          render(products, query);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          clearPanel();
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      if (error) error.hidden = true;
      input.removeAttribute('aria-invalid');
      if (query.length < 2) {
        clearPanel();
        return;
      }
      if (query.length > 200) return;
      clearTimeout(timer);
      timer = setTimeout(function () { search(query); }, 250);
    });

    input.addEventListener('keydown', function (event) {
      var options = list.querySelectorAll('[role="option"]');
      if (event.key === 'ArrowDown' && options.length) {
        event.preventDefault();
        active = Math.min(options.length - 1, active + 1);
        options[active].focus();
      } else if (event.key === 'Escape') {
        clearPanel();
      }
    });

    list.addEventListener('keydown', function (event) {
      var options = list.querySelectorAll('[role="option"]');
      var index = Array.prototype.indexOf.call(options, document.activeElement);
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        var next = options[Math.min(options.length - 1, index + 1)];
        if (next) next.focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (index <= 0) input.focus();
        else options[index - 1].focus();
      } else if (event.key === 'Escape') {
        clearPanel();
        input.focus();
      }
    });

    form.addEventListener('submit', function (event) {
      var query = input.value.trim();
      if (!query || query.length > 200) {
        event.preventDefault();
        input.setAttribute('aria-invalid', 'true');
        if (error) {
          error.hidden = false;
          error.textContent = !query ? (strings.searchNeed || 'Enter a word to search.') : (strings.searchLong || 'Search text must be 200 characters or fewer.');
        }
      } else {
        input.value = query;
      }
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) clearPanel();
    });
  });
})();
